import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class HttpService {

	constructor(private http: HttpClient) { }

	public async getDataWithOfflineCheck<T>(url: string, options: any = undefined) {
		const promise = (await firstValueFrom(this.http.get<T>(url, options)) as any);
		return promise;
	}

	public getDataWithOfflineCheckNoAwait<T>(url: string, options: any = undefined): Promise<T> {
		return (firstValueFrom(this.http.get<T>(url, options)) as any).then((t: any) => {
			return t;
		})
	}

	public async postWithOfflineHandling<T>(url: string, postModel: any): Promise<T> {
		const promise = (await firstValueFrom(this.http.post<T>(url, postModel)) as any);
		return promise;
	}

	public async patchWithOfflineHandling<T>(url: string, patchModel: any): Promise<T> {
		const promise = await firstValueFrom(this.http.patch<T>(url, patchModel));
		return promise;
	}

	public async deleteWithOfflineHandling<T>(url: string, options: any = undefined): Promise<T> {
		const promise = await firstValueFrom(this.http.delete<T>(url, options)) as any;
		return promise;
	}
}
